module.exports = __webpack_public_path__ + "06_mole.015dee05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/06_mole.png
// module id = E/rr
// module chunks = 0